import { type RefObject, useLayoutEffect, useState } from 'react'

export const useIsOverflowing = (ref: RefObject<HTMLElement>) => {
  const [isOverflowing, setIsOverflowing] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    const measure = () => {
      setIsOverflowing(element.scrollHeight > element.clientHeight)
    }

    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)

    return () => observer.disconnect()
  }, [ref])

  return isOverflowing
}
